export default "__VITE_ASSET__wS2JouVh__"